import { Observable } from "rxjs"
import GovPoolData from "./RandomsModel/GovPoolData"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function GovPoolsObservable(): Observable<GovPoolData[]> {
  return ObservableFromFetch<GovPoolData[]>("GovDonor/GetGovPools")
}
